// App.jsx - Updated
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";

// Pages
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard/Dashboard";
import Workspaces from "./pages/Workspace";
import Projects from "./pages/Projects";
import Tasks from "./pages/Tasks";
import Members from "./pages/Members";
import AcceptInvite from "./pages/AcceptInvite";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import Profile from "./pages/Profile"; // Add this import

// Layout
import Layout from "./components/Layout/Layout";

// ------------------ Private Route Component ------------------
const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  console.log("PrivateRoute - User:", user, "Loading:", loading);
  
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }
  
  if (!user) {
    console.log("No user found, redirecting to login");
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

// ------------------ Layout Wrapper ------------------
const LayoutWrapper = ({ children }) => {
  return (
    <PrivateRoute>
      <Layout>{children}</Layout>
    </PrivateRoute>
  );
};

// ------------------ Public Only Route ------------------
const PublicOnlyRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  console.log("PublicOnlyRoute - User:", user, "Loading:", loading);
  
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }
  
  if (user) {
    console.log("User already logged in, redirecting to dashboard");
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

// ------------------ App Component ------------------
function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes - Available to all */}
          <Route path="/" element={<Home />} />
          
          {/* Public Only Routes - Redirect if already logged in */}
          <Route path="/login" element={
            <PublicOnlyRoute>
              <Login />
            </PublicOnlyRoute>
          } />
          
          <Route path="/register" element={
            <PublicOnlyRoute>
              <Register />
            </PublicOnlyRoute>
          } />
          
          <Route path="/invite/accept" element={<AcceptInvite />} />

          {/* Protected Routes - Require authentication */}
          <Route path="/dashboard" element={
            <LayoutWrapper>
              <Dashboard />
            </LayoutWrapper>
          } />
          
          <Route path="/workspaces" element={
            <LayoutWrapper>
              <Workspaces />
            </LayoutWrapper>
          } />
          
          <Route path="/projects" element={
            <LayoutWrapper>
              <Projects />
            </LayoutWrapper>
          } />
          
          <Route path="/tasks" element={
            <LayoutWrapper>
              <Tasks />
            </LayoutWrapper>
          } />
          
          <Route path="/members" element={
            <LayoutWrapper>
              <Members />
            </LayoutWrapper>
          } />
          
          <Route path="/reports" element={
            <LayoutWrapper>
              <Reports />
            </LayoutWrapper>
          } />
          
          <Route path="/settings" element={
            <LayoutWrapper>
              <Settings />
            </LayoutWrapper>
          } />

          {/* Add Profile Route */}
          <Route path="/profile" element={
            <LayoutWrapper>
              <Profile />
            </LayoutWrapper>
          } />

          {/* Catch-all - SIMPLIFIED */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;